import { createSlice } from '@reduxjs/toolkit'

/**
 * Purchasing-wide VAT display preference, shared by every Purchasing tab.
 * 'ex'  — figures exclude VAT (default, matches the ticket)
 * 'inc' — figures include VAT
 */
export const VAT_PREFERENCE = Object.freeze({
  EX: 'ex',
  INC: 'inc',
})

const initialState = {
  preference: VAT_PREFERENCE.EX,
}

const vatPreferenceSlice = createSlice({
  name: 'vatPreference',
  initialState,
  reducers: {
    setVatPreference: (state, action) => {
      state.preference = action.payload
    },
  },
})

export const { setVatPreference } = vatPreferenceSlice.actions

export const selectVatPreference = state =>
  state.vatPreference?.preference ?? VAT_PREFERENCE.EX

export const selectIsIncVat = state =>
  selectVatPreference(state) === VAT_PREFERENCE.INC

export default vatPreferenceSlice
